import Axios from "axios";
import Url from "app/shared/constants/Url";
const FetchCMList = async ({
  page = 0,
  size = 50,
  search = "",
  serviceId = "",
  ppcId = "",
  departmentId = "",
  designationId = "",
  isActiveUser = "",
  companyId = "",
  projectCategoryId = "",
}) => {
  let URL = Url.EmployeeMaster.emList;
  let userId = localStorage.getItem("userId");
  let token = localStorage.getItem("springToken");
  const requestParams = {
    auth_key: token,
    user_id: userId,
  };
  try {
    const response = await Axios.get(URL, {
      params: {
        sortBy: "",
        sortDirection: "desc",
        search,
        page,
        size,
        auth_key: token,
        user_id: userId,
        serviceId,
        ppcId,
        departmentId,
        designationId,
        isActiveUser,
        companyId,
        projectCategoryId,
      },
      headers: {
        accept: "application/json",
      },
    });
    console.log(response, "response");
    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(
      "Error fetching clients",
      error.response?.data || error.message,
    );
    throw error;
  }
};

export default FetchCMList;

// ?page=${encodeURIComponent(page)}&size=${encodeURIComponent(size)}
